var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-collapse-transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.baseInfo.customerCode"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.rtlSapId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rtlSapId", $$v)
                        },
                        expression: "form.rtlSapId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "rtlFullName_" + (_vm.isQzkh ? "qzkh" : ""),
                    attrs: {
                      prop: "rtlFullName",
                      rules: _vm.isQzkh
                        ? _vm.rules.validateIpt.concat(_vm.rules.iptEmpty)
                        : [],
                      label: _vm.$t("retailStoresInfo.form.baseInfo.storeName"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: {
                        val: _vm.form.rtlFullName,
                        tipable: "",
                        maxlength: 50,
                        disabled: !_vm.isQzkh,
                        mode: _vm.type,
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "rtlFullName", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.baseInfo.retailerRTMCategory"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value:
                          _vm.lookupList["STORE_RTM_TYPE_MAPPING"][
                            _vm.form.rtlRtmCategory
                          ],
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.lookupList["STORE_RTM_TYPE_MAPPING"],
                            _vm.form.rtlRtmCategory,
                            $$v
                          )
                        },
                        expression:
                          "lookupList['STORE_RTM_TYPE_MAPPING'][form.rtlRtmCategory]",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.baseInfo.retailerCategory"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.retailerType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "retailerType", $$v)
                        },
                        expression: "form.retailerType",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.baseInfo.retailerCategoryDescription"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        value: _vm.formatRType(
                          _vm.form.retailerTypeDescription
                        ),
                        clearable: "",
                        disabled: "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.moreInfo.customerCreationTime"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.registrationDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "registrationDate", $$v)
                        },
                        expression: "form.registrationDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isQzkh && _vm.type === "edit"
              ? _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        key:
                          "PCD_" + _vm.type + "_" + (_vm.isQzkh ? "qzkh" : ""),
                        attrs: {
                          prop: "PCD",
                          rules: _vm.rules.chooseEmpty,
                          label: _vm.$t(
                            "storeVisitReport.basic.provinceCityDistrict"
                          ),
                        },
                      },
                      [
                        _c("FormCascader", {
                          attrs: {
                            "target-form": _vm.form,
                            "key-list": [
                              "rtlRegion",
                              "rtlRegionCode",
                              "rtlCity",
                              "rtlCityCode",
                              "rtlDistrict",
                              "rtlDistrictCode",
                            ],
                            mode: _vm.type,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "retailStoresInfo.form.baseInfo.province"
                            ),
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.form.rtlRegion, disabled: "" },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.form, "rtlRegion", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "retailStoresInfo.form.baseInfo.city"
                            ),
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.form.rtlCity, disabled: "" },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.form, "rtlCity", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "retailStoresInfo.form.baseInfo.district"
                            ),
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.form.rtlDistrict, disabled: "" },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.form, "rtlDistrict", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "rtlAddress_" + (_vm.isQzkh ? "qzkh" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "rtlAddress",
                      rules: _vm.isQzkh
                        ? _vm.rules.validateIpt.concat(_vm.rules.iptEmpty)
                        : [],
                      label: _vm.$t("retailStoresInfo.form.baseInfo.address"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: {
                        val: _vm.form.rtlAddress,
                        tipable: "",
                        maxlength: 100,
                        disabled: !_vm.isQzkh,
                        mode: _vm.type,
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "rtlAddress", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "contactsNameOne_" + (_vm.isQzkh ? "qzkh" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "contactsNameOne",
                      rules: _vm.isQzkh
                        ? _vm.rules.validateIpt.concat(_vm.rules.iptEmpty)
                        : [],
                      label: _vm.$t("retailStoresInfo.form.baseInfo.contacts1"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: {
                        val: _vm.form.contactsNameOne,
                        maxlength: 10,
                        disabled: !_vm.isQzkh,
                        mode: _vm.type,
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "contactsNameOne", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "contactsMobileOne_" + (_vm.isQzkh ? "qzkh" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "contactsMobileOne",
                      rules: _vm.isQzkh
                        ? _vm.rules.phoneEmpty.concat(_vm.rules.validatePhone)
                        : [],
                      label: _vm.$t("retailStoresInfo.form.baseInfo.mobile"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: {
                        val: _vm.form.contactsMobileOne,
                        disabled: !_vm.isQzkh,
                        mode: _vm.type,
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "contactsMobileOne", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t("retailStoresInfo.form.moreInfo.empNo"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.empNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "empNo", $$v)
                        },
                        expression: "form.empNo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("retailStoresInfo.form.moreInfo.empName"),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "10", clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.empName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "empName", $$v)
                        },
                        expression: "form.empName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.moreInfo.serviceProvince"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.spFullName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "spFullName", $$v)
                        },
                        expression: "form.spFullName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }